import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';

const TopicCategoryDetailNavigationHeaderRight = React.memo(() => {
  const router = useRouter();
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();

  const onViewAllCategories = useCallback(() => {
    router.push('/topics');
  }, [router]);

  const label = t('nav.routes.topics.viewAllCategories');

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="book"
        label={isXS ? undefined : label}
        tooltip={t('nav.routes.topics.viewAllCategoriesTitle')}
        accessibilityLabel={label}
        onPress={onViewAllCategories}
      />
    </NavigationBarButtonContainer>
  );
});

TopicCategoryDetailNavigationHeaderRight.displayName = 'TopicCategoryDetailNavigationHeaderRight';

export function getTopicCategoryDetailRouteNavigationOptions(title) {
  return {
    title,
    headerTitle: title,
    headerBackVisible: true,
    headerRight: () => <TopicCategoryDetailNavigationHeaderRight />,
  };
}

export default getTopicCategoryDetailRouteNavigationOptions;
